var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCallCancel = function SvgCallCancel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17.256 3.923a.833.833 0 0 0-1.179-1.179L9.031 9.79a10 10 0 0 1-.874-1.203c-.112-.181-.098-.467.124-.689.613-.612.84-1.511.59-2.34l-.248-.83A3.13 3.13 0 0 0 5.628 2.5c-1.68 0-3.24 1.403-2.92 3.258a14.1 14.1 0 0 0 3.37 6.986l-3.334 3.333a.833.833 0 1 0 1.179 1.179zm-9.997 7.64.59-.59q-.614-.709-1.109-1.509c-.57-.923-.333-2.048.363-2.744a.69.69 0 0 0 .172-.684l-.248-.829a1.46 1.46 0 0 0-1.399-1.04c-.854 0-1.388.667-1.278 1.308a12.45 12.45 0 0 0 2.909 6.088",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.526 15.65a12.4 12.4 0 0 1-4.752-1.889l-1.2 1.2a14.1 14.1 0 0 0 5.669 2.331c1.855.32 3.258-1.24 3.258-2.92 0-1.38-.905-2.598-2.228-2.995l-.829-.248a2.35 2.35 0 0 0-2.341.59.61.61 0 0 1-.478.191l-1.249 1.249.161.101c.923.571 2.049.333 2.744-.363a.69.69 0 0 1 .684-.172l.829.249a1.46 1.46 0 0 1 1.04 1.398c0 .854-.666 1.389-1.308 1.278"
  })));
};
export default SvgCallCancel;